import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './guards/auth-interceptor';
import { NoCacheHeadersInterceptor } from './guards/no-cache-headers-interceptor';
import { HelpersModule } from './helpers/helpers.module';
import { ChallengeImproveModule } from './pages/challenge-improve/challenge-improve.module';
import { DuelistsListModule } from './pages/duelists-list/duelists-list.module';

registerLocaleData(localeDe, localeDeExtra);

@NgModule({
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		BrowserModule,
		IonicModule.forRoot({
			rippleEffect: false,
			mode: 'md',
		}),
		AppRoutingModule,
		CommonModule,
		ChallengeImproveModule,
		DuelistsListModule,
		HelpersModule,
	],
	providers: [
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: NoCacheHeadersInterceptor, multi: true },
		{ provide: LOCALE_ID, useValue: 'de' },
		DatePipe,
		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class AppModule {}
